// Use to replace the default useLocation hook
// which can throw an error when called in a modal

const useLocation = () => window.location;

export default useLocation;